import { render, staticRenderFns } from "./life_record_audit.vue?vue&type=template&id=5c9c3776"
import script from "./life_record_audit.vue?vue&type=script&lang=js"
export * from "./life_record_audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports